export default [
  {
    path: "/temp-ngo",
    name: "temp-ngo",
    redirect: "/temp-ngo/temp-account-info",
    component: () => import("./moduleLayout.vue"),
    meta: {
      temp: true,
    },
    children: [
      {
        path: "temp-account-info",
        name: "temp-account-info",
        component: () => import("./pages/account-info/index.vue"),
        meta: {
          pageTitle: "ملف المنظمة ",
          temp: true,

          breadcrumb: [
            {
              text: "معلومات الحساب",
              active: true,
            },
          ],
        },
      },
      {
        path: "temp-ngo-info",
        name: "temp-ngo-info",
        component: () => import("./pages/ngo-info/index.vue"),
        meta: {
          pageTitle: "ملف المنظمة",
          temp: true,

          breadcrumb: [
            {
              text: "معلومات المنظمة",
              active: true,
            },
          ],
        },
      },
      {
        path: "temp-founders-info",
        name: "temp-founders-info",
        component: () => import("./pages/founders-info/index.vue"),
        meta: {
          pageTitle: "ملف المنظمة ",
          temp: true,

          breadcrumb: [
            {
              text: "الأعضاء المؤسسين",
              active: true,
            },
          ],
        },
      },
      {
        path: "ministry-track",
        name: "ministry-track",
        component: () => import("./pages/ministry-track/index.vue"),
        meta: {
          pageTitle: "ملف المنظمة ",
          temp: true,

          breadcrumb: [
            {
              text: "سير المعاملة",
              active: true,
            },
          ],
        },
      },
      {
        path: "docs-upload",
        name: "docs-upload",
        component: () => import("./pages/docs-upload/index.vue"),
        meta: {
          pageTitle: "ملف المنظمة",
          temp: true,
          breadcrumb: [
            {
              text: "وثائق التأسيس",
              active: true,
            },
          ],
        },
      },
    ],
  },
];
